import { toast } from 'sonner';
import {
  usePersonDocuments,
  useSetPersonDocument,
} from '../../../../hooks/onboardingOps';
import { AssignItemList } from '../../../../components/onboarding/AssignItemList';
import { ApiError } from '../../../../lib/api';

/** Pick the documents the new starter has to read and sign. */
export function DocumentsStep({ personId }: { personId: string }) {
  const documents = usePersonDocuments(personId);
  const set = useSetPersonDocument(personId);

  async function toggle(documentId: string, assigned: boolean) {
    try {
      await set.mutateAsync({ documentId, assigned });
    } catch (err) {
      toast.error(err instanceof ApiError ? err.message : 'Could not update');
    }
  }

  return (
    <AssignItemList
      items={documents.data}
      loading={documents.isLoading}
      pending={set.isPending}
      emptyTitle="No documents to sign"
      emptyDescription="Upload contracts and policies under Onboarding, Documents to sign."
      onToggle={(id, assigned) => void toggle(id, assigned)}
    />
  );
}
